import { c as _c } from "react/compiler-runtime";
import './content-feed-avatar.scss';
import React from 'react';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
export interface ContentFeedAvatarProps {
  /** URL of the avatar image */
  src?: string;
  /** Accessible alt text for the image */
  alt: string;
  /** Additional class names */
  className?: string;
}

/**
 * Circular 42px avatar image with fallback icon.
 * Used in the content feed post header to display the author photo.
 */
export const ContentFeedAvatar: React.FC<ContentFeedAvatarProps> = t0 => {
  const $ = _c(11);
  const {
    src,
    alt,
    className
  } = t0;
  if (!src) {
    let t1;
    if ($[0] !== className) {
      t1 = cn("ContentFeedAvatar ContentFeedAvatar--placeholder flex items-center justify-center", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ArkIcon iconName="user-circle" size="1.5em" />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t1) {
      t3 = <div className={t1} aria-hidden="true">{t2}</div>;
      $[3] = t1;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("ContentFeedAvatar", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== alt || $[8] !== src || $[9] !== t1) {
    t2 = <img src={src} alt={alt} className={t1} loading="lazy" />;
    $[7] = alt;
    $[8] = src;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};